<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="true"
    :before-close="handleClose"
    custom-class="detail-box">
    <div class="detail-main">
      <div class="detail-title">{{item.org_name}}</div>
      <div class="detail-flex">
        <div class="detail-label">注册地址</div>
        <div class="detail-value">{{item.xuke_zhucedi}}</div>
      </div>
      <div class="detail-flex">
        <div class="detail-label">统一信用代码证号</div>
        <div class="detail-value">{{item.org_code}}</div>
      </div>
      <div class="detail-flex" v-if="item.content">
        <div class="detail-label">预警原因</div>
        <div class="detail-value">{{item.content}}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "evaluateDialog",
  data() {
    return {

    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
  },

  components: {},
  created() {

  },
  mounted() {

  },
  methods: {

    handleClose(){
      this.$emit('handleClose',false)
    },
  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
/deep/ {
  .el-icon-close {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
  }
}
  .detail-title {
    width: 100%;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }

  .detail-flex {
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid #E5E5E5;
    &:last-child {
      border: none;
    }
    .detail-label {
      width: 100%;
      font-size: 18px;
      color: #333333;
      font-weight: bold;
    }
    .detail-value {
      width: 100%;
      font-size: 16px;
      color: #1097f5;
      font-weight: bold;
      margin-top: 10px;
    }
  }


</style>


